import { Group, TextProps, Tooltip } from "@mantine/core"
import type { CountryIso3166 } from "@tfg/db"

import { CountryFlag } from "../../atoms/CountryFlag/CountryFlag"
import { CountryMapper } from "../Inputs/CountrySelector/CountrySelector"
import { Missing } from "../Missing/Missing"

import { TextCell } from "./TextCell"

type Props = TextProps & {
  countryIso3166?: CountryIso3166 | null
  dimmed?: boolean
  countriesMapper: CountryMapper
  tooltip?: string | undefined
}

export const CountryCell = ({
  countryIso3166,
  dimmed,
  countriesMapper,
  tooltip,
}: Props) => {
  if (!countryIso3166) return <Missing />

  const dimmedStyle = dimmed ? { filter: "grayscale(75%)" } : {}
  const countryCell = (
    <Group gap={"xs"} style={{ whiteSpace: "nowrap", ...dimmedStyle }}>
      <CountryFlag countryIso3166={countryIso3166} width={16} />
      <TextCell value={countriesMapper[countryIso3166]?.countryName} />
    </Group>
  )
  if (tooltip) {
    return <Tooltip label={tooltip}>{countryCell}</Tooltip>
  }
  return countryCell
}
